<template>
  <div class="posRes mx-4">
    <div class="col-12 w-100 d-flex">
      <div class="dropdown">
        <button
          class="btn btn-secondary dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Mix Credits
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <p class="dropdown-item">Full Stereo Mix: {{ remSterro }}</p>
          <p class="dropdown-item">2 Track Mix: {{ remMixes }}</p>
          <p class="dropdown-item">ATMOS Mix: {{ remAtmos }}</p>
          <p class="dropdown-item">Revisions: {{ remRemixes }}</p>
        </div>
      </div>
      <!-- <div class="col-6 t-box t-left p-2">
        <div class="t-box-inner">
          <div class="d-flex flex-column">
            <div class="dot-wrapper d-flex justify-content-end w-100">
              <div class="dot"></div>
            </div>

            <p class="t-hard">Tracks Left:</p>

            <div class="d-flex justify-content-between">
              <div>
                <p>{{ remMixes }}</p>
              </div>
              <div>
                <a
                  class="btn-add"
                  style="color: #fff"
                  href="https://getmxd.com/products/mixes?variant=16469769486434"
                  target="_blank"
                  ><img src="../assets/plus.png" height="40" width="40" alt=""
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="t-box col-6 t-right p-2">
        <div class="t-box-inner">
          <div class="dot-wrapper d-flex justify-content-end w-100">
            <div class="dot"></div>
          </div>
          <p class="t-hard">Revisions Left:</p>
          <div class="d-flex justify-content-between">
            <div class="">
              <p>
                {{ remRemixes }}
              </p>
            </div>
            <div class="">
              <span>
                <a
                  class="btn-add"
                  style="color: #fff; text-decoration: underline"
                  href="https://getmxd.com/products/remixes?variant=16473368002658"
                  target="_blank"
                  ><img src="../assets/plus.png" height="40" width="40" alt=""
                /></a>
              </span>
            </div>
          </div>
        </div>
      </div> -->
      <!-- </div>

    <div class="col-12 w-100 d-flex">
      <div class="col-6 t-box t-left p-2">
        <div class="t-box-inner">
          <div class="d-flex flex-column">
            <div class="dot-wrapper d-flex justify-content-end w-100">
              <div class="dot"></div>
            </div>

            <p class="t-hard">Atmos Mixes Left:</p>

            <div class="d-flex justify-content-between">
              <div>
                <p>{{ remAtmos }}</p>
              </div>
              <div>
                <a
                  class="btn-add"
                  style="color: #fff"
                  href="https://getmxd.com/products/mixes?variant=16469769486434"
                  target="_blank"
                  ><img src="../assets/plus.png" height="40" width="40" alt=""
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 t-box t-left p-2">
        <div class="t-box-inner">
          <div class="d-flex flex-column">
            <div class="dot-wrapper d-flex justify-content-end w-100">
              <div class="dot"></div>
            </div>

            <p class="t-hard">Stereo Mixes Left:</p>

            <div class="d-flex justify-content-between">
              <div>
                <p>{{ remSterro }}</p>
              </div>
              <div>
                <a
                  class="btn-add"
                  style="color: #fff"
                  href="https://getmxd.com/products/mixes?variant=16469769486434"
                  target="_blank"
                  ><img src="../assets/plus.png" height="40" width="40" alt=""
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    remMixes() {
      return this.$store.state.apiEvents.remainingTracks == -1
        ? "Unlimited"
        : this.$store.state.apiEvents.remainingTracks;
    },
    remRemixes() {
      return this.$store.state.apiEvents.remainingRevisions == -1
        ? "Unlimited"
        : this.$store.state.apiEvents.remainingRevisions;
    },
    remAtmos() {
      return this.$store.state.apiEvents.remainingAtmosMix == -1
        ? "Unlimited"
        : this.$store.state.apiEvents.remainingAtmosMix;
    },
    remSterro() {
      return this.$store.state.apiEvents.remainingStereoMix == -1
        ? "Unlimited"
        : this.$store.state.apiEvents.remainingStereoMix;
    },
  },
};
</script>

<style scoped>
.leftNavItems {
  color: #fff;
  font-size: 15px;
  font-family: "Open Sans";
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.83px;
}
.posRel {
}
.t-box .t-box-inner {
  height: 130px;
  border-radius: 12px;
  padding: 8px;
}
.t-left div {
  background-color: #445dab;
}
.t-right div {
  background-color: #25429d;
}
.dot-wrapper {
  height: auto !important;
}
.dot {
  margin: 3px;
  height: 16px !important;
  width: 16px !important;
  border-radius: 50%;
  background-color: #fff !important;
}
.t-hard {
  /* font-weight: bold; */
}
.btn-add {
  color: black !important;
  text-decoration: none !important;
}
</style>
